var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amf-form',{attrs:{"title":'Welcome, ' + _vm.userName}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c(_vm.roleDashboard,{tag:"div",staticClass:"col-12"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e343ffb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/dashboards/MainDashboard.vue
// module id = null
// module chunks = 